export default "__VITE_ASSET__f289e6d2__"